import { render, staticRenderFns } from "./inspectionSettings.vue?vue&type=template&id=53fe6e6c&scoped=true&"
import script from "./inspectionSettings.vue?vue&type=script&lang=js&"
export * from "./inspectionSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fe6e6c",
  null
  
)

export default component.exports